import React, { Component, Fragment } from 'react';
import { I18n } from 'react-redux-i18n';
import { css } from 'aphrodite/no-important';
import styles from './AccordionSite.styles';

import AccordionMenu from '../accordionmenu/AccordionMenu';
import AccordionArea from '../accordionarea/AccordionArea';
import Icon from '../../common/icon/Icon';

class AccordionSite extends Component {
  state = {
    isOpen: false
  };
  options = [
    {
      text: I18n.t('edit.edit'),
      value: 'edit'
    },
    {
      text: I18n.t('delete.delete'),
      value: 'delete'
    },
    {
      text: I18n.t('edit.labels.labels'),
      value: 'labels'
    }
  ];
  toggleOpen = () => {
    if (!!this.props.site.areaCount) {
      let isOpen = !this.state.isOpen;
      if (isOpen) {
        this.props.onOpenSite(this.props.site.id);
      }
      this.setState({ isOpen });
    }
  };
  handleSiteActions = action => {
    switch (action) {
      case 'delete':
        this.props.delete(this.props.site);
        break;

      case 'edit':
        this.props.onEditSite(this.props.site);
        break;

      case 'labels':
        this.props.onEditSiteLabels(this.props.site);
        break;
    
      default:
        break;
    }
    if (action === 'delete') {
      this.props.delete(this.props.site);
    }
    if (action === 'edit') {
      this.props.onEditSite(this.props.site);
    }
  };
  renderArea = (area, index) => (
    <AccordionArea
      key={index}
      area={area}
      zones={this.props.zones}
      locations={this.props.locations}
      delete={this.props.onDeleteArea}
      edit={this.props.onEditArea}
      onOpenArea={this.props.onOpenArea}
      onOpenZone={this.props.onOpenZone}
      onEditZone={this.props.onEditZone}
      onDeleteLocation={this.props.onDeleteLocation}
      onDeleteZone={this.props.onDeleteZone}
      onEditLocation={this.props.onEditLocation}
    />
  );
  render() {
    let iconStyles = [
      styles.icon,
      ...(!this.props.site.areaCount ? [styles.iconHidden] : [])
    ];
    return (
      <Fragment>
        <div className={css(styles.site, this.state.isOpen && styles.openSite)}>
          <Icon
            value={this.state.isOpen ? 'chevron-up' : 'chevron-down'}
            styles={iconStyles}
            onClick={this.toggleOpen}
          />
          <div className={css(styles.field)}>
            <span className={css(styles.label)}>{I18n.t('assets.site')}</span>
            <span className={css(styles.value)}>{this.props.site.name}</span>
          </div>

          {
            !this.props.hideMenu ?
            <AccordionMenu
              styles={styles.options}
              options={this.options}
              handleClick={this.handleSiteActions}
            /> :
            null
          }

        </div>
        {this.state.isOpen &&
          this.props.site.id in this.props.areas &&
          this.props.areas[this.props.site.id].map(this.renderArea)}
      </Fragment>
    );
  }
}

export default AccordionSite;



// WEBPACK FOOTER //
// ./src/components/data/accordionsite/AccordionSite.js